import Manual from './Manual'
import AddressDetails from './AddressDetails'
import CardholderDetails from './CardholderDetails'
import { INITIAL } from '@linqpal/models/src/dictionaries'

export const flow = {
  initial: INITIAL,
  Manual,
  AddressDetails,
  CardholderDetails,
}
